import type { DocNode } from '@atlaskit/adf-schema/doc';
import { reduce } from '@atlaskit/adf-utils/traverse';
import { toAtlassianMarkdown } from '@atlassian/conversation-assistant-content-transformer/whatsapp-markdown/toAtlassianMarkdown';

import { encodeAdf } from './content-transformer/main';

const textLength = (doc: DocNode): number =>
	reduce(doc, (total, node) => total + (node.text?.length ?? 0), 0);

const asTextParagraph = (text: string): DocNode => ({
	version: 1,
	type: 'doc',
	content: [{ type: 'paragraph', content: [{ type: 'text', text }] }],
});

/**
 * Decode a WhatsApp-markdown body to ADF. A bare marker line (e.g. `***`, `---`)
 * is literal text in WhatsApp but encodes to an empty block, so fall back to a
 * plain-text paragraph when the result has no visible text.
 */
export const whatsAppMarkdownToAdf = (body: string): DocNode => {
	const doc = encodeAdf(toAtlassianMarkdown(body));
	return textLength(doc) === 0 ? asTextParagraph(body) : doc;
};
